import {Component, Inject, OnInit, PLATFORM_ID} from '@angular/core';
import {TranslateHelperService} from './services/helpers/translate-helper.service';
import { ActivePageHelperService } from './services/helpers/active-page-helper.service';
import { EchoHelperService } from './services/helpers/echo-helper.service';
import { AuthenticationHelperService } from './services/helpers/authentication-helper.service';
import { register as registerSwiperElements } from 'swiper/element/bundle';
import {isPlatformBrowser} from '@angular/common';
registerSwiperElements();
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html'
})
export class AppComponent implements OnInit {

  constructor(
    private translateHelper: TranslateHelperService,
    public activePageHelper: ActivePageHelperService,
    private echoHelperService: EchoHelperService,
    public authenticationHelperService: AuthenticationHelperService,
    @Inject(PLATFORM_ID) private platformId: string
  ) {
    this.translateHelper.initTranslate();
    this.initializeEchoOnAuthChange();
  }

  ngOnInit(): void {
    // this.homepageDataService.startAutoRefresh();
  }

  private initializeEchoOnAuthChange(): void {
    this.authenticationHelperService.authStatus$.subscribe((userData: boolean) => {
      if (userData && isPlatformBrowser(this.platformId)) {
        this.initialize();
      }
    });
  }

  initialize(): void {
    try {
      this.echoHelperService.initEcho();
    } catch (error) {
    }
    (window as any).Echo.connector.pusher.connection.bind('failed', () => {
      this.echoHelperService.initEcho();
    });
  }
}
